import { Node, mergeAttributes } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-2";
import ProjectAbbreviationWidget from "./ProjectAbbreviationWidget.vue";
import ProjectVerboseAbbreviationWidget from "./ProjectVerboseAbbreviationWidget.vue";

export const ProjectAbbreviation = Node.create({
  name: "otiumAbbreviation",

  group: "inline",
  inline: true,
  atom: true,
  selectable: true,

  addAttributes() {
    return {
      name: {
        default: "test"
      }
    };
  },

  parseHTML() {
    return [
      {
        tag: "otium-abbreviation"
      }
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["otium-abbreviation", mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return VueNodeViewRenderer(ProjectAbbreviationWidget);
  }
});

export const ProjectVerboseAbbreviation = Node.create({
  name: "otiumVerboseAbbreviation",

  group: "inline",
  inline: true,
  atom: true,
  selectable: true,

  addAttributes() {
    return {
      name: {
        default: "test"
      }
    };
  },

  parseHTML() {
    return [
      {
        tag: "otium-verbose-abbreviation"
      }
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["otium-verbose-abbreviation", mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return VueNodeViewRenderer(ProjectVerboseAbbreviationWidget);
  }
});
